module.exports = __webpack_public_path__ + "media/images/icons/icon-add-store-6898af562ae0a019522673bd985dce2f.svg";